import React from "react";
import Container from "../General/Container/Container";
import MinifiedRecommendedItem from "./MinifiedRecommendedItem";

const MinifiedRecommended = ({
    data,
    setHeActiveKeys,
    setAiActiveKeys,
    onChangeName,
}) => {
    return <Container className="minified-result-item dcol align-center">
        <span className="minified-result-item-title">Audience Package Recommendation</span>
        <span className="border-item" />
        <Container className="minified-recommended drow align-stretch gap-3 justify-center">
            {data.map((item) => {
                if(!item?.data?.list?.length) return null;
                return <MinifiedRecommendedItem
                    key={item.key}
                    itemId={item.key}
                    data={item.data}
                    setHeActiveKeys={setHeActiveKeys}
                    setAiActiveKeys={setAiActiveKeys}
                    onChangeName={onChangeName}
                />
            })}
        </Container>
    </Container>
}

export default MinifiedRecommended